import Cookies, { CookieAttributes } from 'js-cookie';

const getRootDomain = (): string => {
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname.split('.');
  return host.length >= 2 ? host.slice(-2).join('.') : '';
};

export function setSiteCookie(
  name: string,
  value: string,
  options: CookieAttributes = {}
) {
  const root = getRootDomain();

  Cookies.remove(name, { path: '/' });

  Cookies.set(name, value, {
    path: '/',
    secure: true,
    sameSite: 'Lax',
    ...(root ? { domain: `.${root}` } : {}),
    ...options,
  });
}

export const getSiteCookie = (name: string) => Cookies.get(name);
export const removeSiteCookie = (name: string) => {
  const root = getRootDomain();

  if (root) {
    Cookies.remove(name, { domain: `.${root}`, path: '/' });
  }

  Cookies.remove(name, { path: '/' });
};